<template>
    <div class="page-content">
        <SketchBreadcrumb pageName="Indicatori"></SketchBreadcrumb>
        <div class="padding-box">
            <div class="white-box flex space-between align-center">
                <div ref="scrollTo">
                    <h3 class="module-title">Completează cu atenție detaliile cu privire la Indicatorii proiectului</h3>
                    <p>Aceaste informații vor fi introduse in sistemul informatic MySmis.</p>
                </div>
                <img src="@/assets/images/M3/M3Sketch/warning-sign.png" class="warning-sign">
            </div>
            <IndicatoriProiect
                :indicatori="getIndicators"
                @formComplete="completePage(true)"
                @formIncomplete="completePage(false)"
                @changePercentIndicator="$emit('changePercentIndicator')"
                @changeProductIndicator="$emit('changeProductIndicator')"
                @inputsChanged="inputsChanged = $event"
                @indicatorsSaved="$emit('achizitiiChanged')"
            >
            </IndicatoriProiect>
            <b-icon-chevron-up class="back-to-top" @click="scrollToTop()"></b-icon-chevron-up>
        </div>
        <ChangeRoutePopup :schimbaModal="showModal"
                          @hideTempModal="showModal = false"
                          @changeRoute="leavePage($event)"
        ></ChangeRoutePopup>
    </div>
</template>


<script>
    import IndicatoriProiect from '@/pages/Aplicatii/M3/M3Sketch/components/indicatori-forms/IndicatoriProiect'
    import ChangeRoutePopup from "../components/ChangeRoutePopup";
    import {changeRoute} from "../../../../../helpers/helpers";
    import SketchBreadcrumb from '@/pages/Aplicatii/M3/M3Sketch/components/SketchBreadcrumb'
    import { BIconChevronUp } from 'bootstrap-vue'

    export default {
        components: {
            IndicatoriProiect,
            ChangeRoutePopup,
            SketchBreadcrumb,
            BIconChevronUp
        },
        data() {
            return {
                indicatori: null,
                completed: false,
                inputsChanged: false,
                showModal: false,
                next: null,
            }
        },

        computed: {
            getIndicators() {
                return this.allData && this.allData.m3_project && this.allData.m3_project.indicators ? this.allData.m3_project.indicators : []
            },
            allData() {
                return this.$store.getters['m3Sketch/allData']
            }
        },
        beforeRouteLeave (to, from, next) {

            this.next = next;

            if(to.path === '/login' || to.path === '/logout')
                this.next();

            if(this.completed)
                this.next();

            if(this.inputsChanged)
                this.showModal = true;
            else
                this.next();

        },

        mounted() {
            this.$store.dispatch('pageLoading/setLoading', false)
        },

        methods: {
            completePage(event) {
                this.section = {
                    section: 'indicatori'
                }
                this.completed = event;
                if(this.completed){
                    this.inputsChanged = false;
                    this.$store.dispatch('pages/addPage', this.section)
                    this.$emit('achizitiiChanged');
                } else{
                    this.$store.dispatch('pages/removePage', this.section)
                }
            },

            leavePage(event){
                changeRoute(event, this.next);

                if(!event)
                    this.showModal = false;
            },

            scrollToTop() {
                this.$refs.scrollTo.scrollIntoView({behavior: 'smooth', block: "center"});
            },
        }
    }
</script>

<style scoped>
.back-to-top{
    cursor: pointer;
    position: sticky;
    bottom: -10px;
    left: 100%;
    color: #fff;
    z-index: 99999;
    padding: 4px;
    border-radius: 4px;
    font-size: 25px;
    background: #8c6984;
}
.space-between{
    justify-content: space-between;
}
.white-box{
    background: #fff;
    padding: 20px;
}
.module-title{
    margin: 0;
    color: #5b6276;
    font-size: 14px;
    margin-bottom: 5px;
}
.white-box{
    width: 100%;
}
.white-box p{
    color: #777e90;
    font-size: 12px;
    margin: 0;
    max-width: 960px;
}
.warning-sign{
    margin-left: 50px;
}
</style>
